"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TraitSelector extends Marko.Component {
    constructor() {
        super(...arguments);
        this.trait = { name: '', values: [] };
        this.selectedTraits = {};
        this.variations = {};
        this.state = {
            selected: '-1',
            errorMessage: false,
        };
    }
    onCreate(input) {
        this.trait = input && input.trait;
        this.selectedTraits = (input && input.selectedTraits) || {};
        this.variations = input && input.variations;
        this.filteredValues = this.getFilteredValues();
        this.state = {
            selected: (input && input.selectedValue) || '-1',
            errorMessage: false,
        };
    }
    onInput(input) {
        this.trait = input && input.trait;
        this.selectedTraits = (input && input.selectedTraits) || {};
        this.state.selected = (input && input.selectedValue) || '-1';
        this.variations = input && input.variations;
        this.filteredValues = this.getFilteredValues();
        if (input && input.error && this.state.selected === '-1') {
            this.state.errorMessage = true;
        }
    }
    handleChange(event) {
        const selected = event.selected;
        const wasClicked = event.wasClicked;
        if (selected && selected[0] !== '-1')
            this.state.errorMessage = false;
        this.state.selected = String(selected[0]);
        if (wasClicked) {
            const selectedTrait = {};
            selectedTrait[this.trait.name] = this.getValueByName(String(selected[0])) || { name: '', possibleVariations: [] };
            this.emit('traitChange', selectedTrait);
        }
    }
    isOutOfStock(value) {
        const possibleVarsFromSelectedTraits = this.getPossibleVarationsFromSelectedTraits();
        const varIntersectionOfValueAndSelectedTraits = value.possibleVariations.filter((variation) => possibleVarsFromSelectedTraits.includes(variation));
        const variationIds = varIntersectionOfValueAndSelectedTraits.length
            ? varIntersectionOfValueAndSelectedTraits
            : value.possibleVariations;
        const areAllOutOfStock = variationIds.every((id) => this.variations && this.variations[id].outOfStock);
        return areAllOutOfStock;
    }
    getFilteredValues() {
        const values = this.trait.values;
        if (!this.selectedTraits || Object.keys(this.selectedTraits).length === 0)
            return values;
        const possibleVarsFromSelectedTraits = this.getPossibleVarationsFromSelectedTraits();
        if (possibleVarsFromSelectedTraits.length === 0)
            return values;
        const filteredValues = values.filter((value) => value.possibleVariations.some((variation) => possibleVarsFromSelectedTraits.includes(variation)));
        return filteredValues;
    }
    getPossibleVarationsFromSelectedTraits() {
        let possibleVarsFromSelectedTraits = [];
        const combinedPossibleVars = [];
        for (const selectedTrait in this.selectedTraits) {
            if (selectedTrait !== this.trait.name) {
                combinedPossibleVars.push(this.selectedTraits[selectedTrait].possibleVariations);
            }
        }
        if (combinedPossibleVars.length) {
            possibleVarsFromSelectedTraits =
                combinedPossibleVars.reduce((accumulator, currentArray) => accumulator &&
                    accumulator.filter((value) => currentArray && currentArray.includes(value))) || [];
        }
        return possibleVarsFromSelectedTraits;
    }
    getValueByName(name) {
        return this.trait.values.find((value) => value.name === name);
    }
}
exports.default = TraitSelector;
